'use strict';

import React from 'react';
import { connect } from 'react-redux';
import dispatchQuery from 'helpers/dispatchQuery';
import ClassifierComponent from './classifier.component';
import ClassifierQuery from './classifier.query';
import LabelQuery from 'components/labelViewer/labelViewer.query';
import _ from 'lodash';

class ClassifierContainer extends React.Component {

  isValidClassifierId (classifierId) {
    return _.isNumber(classifierId) && !_.isNaN(classifierId);
  }

  fetchClassifiers (classifierName) {
    if (_.isString(classifierName)) {
      const { dispatch } = this.props || this;
      const query = ClassifierQuery.getClassifiers(classifierName);
      dispatchQuery(dispatch, query, 'classifiers', 'classifiers');
    }
  }

  fetchClassifier (classifierId) {
    if (this.isValidClassifierId(classifierId)) {
      const { dispatch } = this.props || this;
      const query = ClassifierQuery.getClassifier(classifierId);
      dispatchQuery(dispatch, query, 'classifierDetail', 'classifierDetail');
    }
  }

  fetchLabels (labelName) {
    if (_.isString(labelName)) {
      const { dispatch } = this.props;
      const query = LabelQuery.getLabelsByName(labelName);
      dispatchQuery(dispatch, query, 'filteredLabels', 'filteredLabels');
    }
  }

  fetchWeightedLabels (clfTargetId, classifierId) {
    const { dispatch } = this.props;
    const query = ClassifierQuery.getWeightedClfTargets(classifierId, clfTargetId);
    dispatchQuery(dispatch, query, 'clfTarget', 'clfTarget');
  }

  saveWeightedLabels (weightedLabels) {
    const { dispatch } = this.props;
    const { id, weightedClfTargets } = weightedLabels;
    weightedClfTargets.map((label) => {
      if (!!label.action) {
        const query = ClassifierQuery.getMutationWeightedClfTargetQuery(label.action, id, label.labelId, label.weight);
        dispatchQuery(dispatch, query, 'savedWeightedTarget:', 'savedWeightedTarget:');
      }
    });
  }

  fetchDetectorResults (clfTargetId) {
    const { dispatch } = this.props;
    this.fetchTextDetectors(clfTargetId);

    let query = ClassifierQuery.getBoxDetectorResults(clfTargetId);
    dispatchQuery(dispatch, query, 'boxDetectorResults');

    query = ClassifierQuery.getVideoDetectorResults(clfTargetId);
    dispatchQuery(dispatch, query, 'videoDetectorResults');
  }

  fetchTextDetectors (clfTargetId, lastTextDetectorId) {
    const { dispatch } = this.props;
    const query = ClassifierQuery.getTextDetectorResults(clfTargetId, lastTextDetectorId);
    dispatchQuery(dispatch, query, 'textDetectorResults');
  }

  fetchMTurkQaEnabled (clfTargetId) {
    const { dispatch } = this.props;
    const query = ClassifierQuery.getClfTargetMturkQaEnabled(clfTargetId);
    dispatchQuery(dispatch, query, 'turkQaEnabled');
  }

  fetchEvaluator (targetLabelId, selectedEvaluator) {
    const { dispatch } = this.props;
    const query = ClassifierQuery.getMTurkEvaluator(selectedEvaluator, targetLabelId);
    dispatchQuery(dispatch, query, 'mturkEvaluator');
  }

  saveEvaluator (entityName, mturkEvaluator, clfTargetId) {
    const { dispatch } = this.props;
    const query = ClassifierQuery.getMutationMTurkEvaluator(entityName, mturkEvaluator, clfTargetId);
    dispatchQuery(dispatch, query, 'savedMTurkEvaluator');
  }

  componentDidMount () {
    this.fetchClassifier(parseInt(this.props.params.classifierId));
  }

  componentWillReceiveProps (nextProps) {
    const { classifierId } = nextProps.params;
    this.fetchClassifier(parseInt(classifierId));
  }

  render() {
    const { classifierId } = this.props.params;
    const isFetchingOnMount = !!classifierId && this.isValidClassifierId(parseInt(classifierId));
    return (
      <div className="Grid">
        <div className="Grid-cell--1">
          <div className="Grid-content">
            <ClassifierComponent
              isFetchingOnMount={isFetchingOnMount}
              fetchClassifiers={this.fetchClassifiers}
              fetchClassifier={this.fetchClassifier}
              fetchWeightedLabels={this.fetchWeightedLabels.bind(this)}
              fetchLabels={this.fetchLabels.bind(this)}
              saveWeightedLabels={this.saveWeightedLabels.bind(this)}
              fetchDetectorResults={this.fetchDetectorResults.bind(this)}
              fetchTextDetectors={this.fetchTextDetectors.bind(this)}
              fetchMTurkQaEnabled={this.fetchMTurkQaEnabled.bind(this)}
              fetchEvaluator={this.fetchEvaluator.bind(this)}
              saveEvaluator={this.saveEvaluator.bind(this)}/>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(ClassifierContainer);



// WEBPACK FOOTER //
// ./src/components/classifier/classifier.container.jsx